import { GET_USERS, ADD_USER, EDIT_USER, DELETE_USER } from "./actions";

const initialState = {
  users: [],
};

export function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_USERS:
    case EDIT_USER:
    case DELETE_USER:
      return { ...state, users: action.payload };
    case ADD_USER:
      return { ...state, users: [...state.users, action.payload] };
    default:
      return state;
  }
}
